import axios from 'axios';
import Auth from '../../auth/auth';

const auth = new Auth();
const headers = () => ({
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'x-access-token': auth.getAccessToken(),
});

const cancelSources = {};

function cancelPrevious(key) {
  // eslint-disable-next-line security/detect-object-injection -- key is a hardcoded string literal at every call site
  if (cancelSources[key]) {
    // eslint-disable-next-line security/detect-object-injection -- same as above
    cancelSources[key].cancel();
  }
  const source = axios.CancelToken.source();
  // eslint-disable-next-line security/detect-object-injection -- same as above
  cancelSources[key] = source;
  return source;
}

export const scActions = {
  LOAD_CONNECTIONS_REQUEST: 'SC_LOAD_CONNECTIONS_REQUEST',
  LOAD_CONNECTIONS_SUCCESS: 'SC_LOAD_CONNECTIONS_SUCCESS',
  LOAD_CONNECTIONS_FAILURE: 'SC_LOAD_CONNECTIONS_FAILURE',

  LOAD_DD_SCHEMAS_REQUEST: 'SC_LOAD_DD_SCHEMAS_REQUEST',
  LOAD_DD_SCHEMAS_SUCCESS: 'SC_LOAD_DD_SCHEMAS_SUCCESS',
  LOAD_DD_SCHEMAS_FAILURE: 'SC_LOAD_DD_SCHEMAS_FAILURE',

  LOAD_SOURCE_SCHEMAS_REQUEST: 'SC_LOAD_SOURCE_SCHEMAS_REQUEST',
  LOAD_SOURCE_SCHEMAS_SUCCESS: 'SC_LOAD_SOURCE_SCHEMAS_SUCCESS',
  LOAD_SOURCE_SCHEMAS_FAILURE: 'SC_LOAD_SOURCE_SCHEMAS_FAILURE',

  LOAD_TARGET_SCHEMAS_REQUEST: 'SC_LOAD_TARGET_SCHEMAS_REQUEST',
  LOAD_TARGET_SCHEMAS_SUCCESS: 'SC_LOAD_TARGET_SCHEMAS_SUCCESS',
  LOAD_TARGET_SCHEMAS_FAILURE: 'SC_LOAD_TARGET_SCHEMAS_FAILURE',

  LOAD_OBJECTS_REQUEST: 'SC_LOAD_OBJECTS_REQUEST',
  LOAD_OBJECTS_SUCCESS: 'SC_LOAD_OBJECTS_SUCCESS',
  LOAD_OBJECTS_FAILURE: 'SC_LOAD_OBJECTS_FAILURE',

  RUN_COMPARISON_REQUEST: 'SC_RUN_COMPARISON_REQUEST',
  RUN_COMPARISON_SUCCESS: 'SC_RUN_COMPARISON_SUCCESS',
  RUN_COMPARISON_FAILURE: 'SC_RUN_COMPARISON_FAILURE',

  LOAD_IMPACT_REQUEST: 'SC_LOAD_IMPACT_REQUEST',
  LOAD_IMPACT_SUCCESS: 'SC_LOAD_IMPACT_SUCCESS',
  LOAD_IMPACT_FAILURE: 'SC_LOAD_IMPACT_FAILURE',

  LOAD_HISTORY_REQUEST: 'SC_LOAD_HISTORY_REQUEST',
  LOAD_HISTORY_SUCCESS: 'SC_LOAD_HISTORY_SUCCESS',
  LOAD_HISTORY_FAILURE: 'SC_LOAD_HISTORY_FAILURE',

  LOAD_SAVED_RUN_REQUEST: 'SC_LOAD_SAVED_RUN_REQUEST',
  LOAD_SAVED_RUN_SUCCESS: 'SC_LOAD_SAVED_RUN_SUCCESS',
  LOAD_SAVED_RUN_FAILURE: 'SC_LOAD_SAVED_RUN_FAILURE',

  CLEAR_RESULT: 'SC_CLEAR_RESULT',
};

export function loadDdSchemas() {
  return function(dispatch) {
    const source = cancelPrevious('loadDdSchemas');
    dispatch({type: scActions.LOAD_DD_SCHEMAS_REQUEST});
    return axios.get(
        `${process.env.REACT_APP_API_URL}/dataDictionary/schemas`,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: scActions.LOAD_DD_SCHEMAS_SUCCESS, payload: json}))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: scActions.LOAD_DD_SCHEMAS_FAILURE, payload: error, error: true});
        });
  };
}

export function loadConnections() {
  return function(dispatch) {
    const source = cancelPrevious('loadConnections');
    dispatch({type: scActions.LOAD_CONNECTIONS_REQUEST});
    return axios.get(
        `${process.env.REACT_APP_API_URL}/manageDb/getDbConnection`,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: scActions.LOAD_CONNECTIONS_SUCCESS, payload: json}))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: scActions.LOAD_CONNECTIONS_FAILURE, payload: error, error: true});
        });
  };
}

export function loadSchemasForSide(connId, side) {
  return function(dispatch) {
    const key = `loadSchemas_${side}`;
    const source = cancelPrevious(key);
    const reqType = side === 'source' ?
      scActions.LOAD_SOURCE_SCHEMAS_REQUEST :
      scActions.LOAD_TARGET_SCHEMAS_REQUEST;
    const succType = side === 'source' ?
      scActions.LOAD_SOURCE_SCHEMAS_SUCCESS :
      scActions.LOAD_TARGET_SCHEMAS_SUCCESS;
    const failType = side === 'source' ?
      scActions.LOAD_SOURCE_SCHEMAS_FAILURE :
      scActions.LOAD_TARGET_SCHEMAS_FAILURE;
    dispatch({type: reqType});
    return axios.get(
        `${process.env.REACT_APP_API_URL}/manageDb/connections/${connId}/schemas`,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: succType, payload: json}))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: failType, payload: error, error: true});
        });
  };
}

export function loadObjects(payload) {
  return function(dispatch) {
    const source = cancelPrevious('loadObjects');
    dispatch({type: scActions.LOAD_OBJECTS_REQUEST});
    // Include per-side source type + DD schema id, and OMIT null/undefined values
    // (a DD side has no connectionId — URLSearchParams would otherwise send "null").
    const params = new URLSearchParams();
    const put = (k, v) => {
      if (v !== undefined && v !== null && v !== '') params.append(k, v);
    };
    put('sourceConnectionId', payload.sourceConnectionId);
    put('sourceSchema', payload.sourceSchema);
    put('sourceType', payload.sourceType);
    put('sourceDdSchemaId', payload.sourceDdSchemaId);
    put('targetConnectionId', payload.targetConnectionId);
    put('targetSchema', payload.targetSchema);
    put('targetType', payload.targetType);
    put('targetDdSchemaId', payload.targetDdSchemaId);
    put('objectTypes', payload.objectTypes);
    return axios.get(
        `${process.env.REACT_APP_API_URL}/schemaComparison/objects?${params.toString()}`,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: scActions.LOAD_OBJECTS_SUCCESS, payload: json}))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: scActions.LOAD_OBJECTS_FAILURE, payload: error, error: true});
        });
  };
}

export function runComparison(payload) {
  return function(dispatch) {
    const source = cancelPrevious('runComparison');
    dispatch({type: scActions.RUN_COMPARISON_REQUEST});
    return axios.post(
        `${process.env.REACT_APP_API_URL}/schemaComparison/compare`,
        payload,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => {
          dispatch({type: scActions.RUN_COMPARISON_SUCCESS, payload: json});
          return json;
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: scActions.RUN_COMPARISON_FAILURE, payload: error, error: true});
          throw error;
        });
  };
}

export function loadImpact(payload) {
  return function(dispatch) {
    const source = cancelPrevious('loadImpact');
    dispatch({type: scActions.LOAD_IMPACT_REQUEST});
    return axios.post(
        `${process.env.REACT_APP_API_URL}/schemaComparison/impact`,
        payload,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: scActions.LOAD_IMPACT_SUCCESS, payload: json}))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: scActions.LOAD_IMPACT_FAILURE, payload: error, error: true});
        });
  };
}

export function loadHistory() {
  return function(dispatch) {
    const source = cancelPrevious('loadHistory');
    dispatch({type: scActions.LOAD_HISTORY_REQUEST});
    return axios.get(
        `${process.env.REACT_APP_API_URL}/schemaComparison/history`,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: scActions.LOAD_HISTORY_SUCCESS, payload: json}))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: scActions.LOAD_HISTORY_FAILURE, payload: error, error: true});
        });
  };
}

export function loadSavedRun(id) {
  return function(dispatch) {
    const source = cancelPrevious('loadSavedRun');
    dispatch({type: scActions.LOAD_SAVED_RUN_REQUEST});
    return axios.get(
        `${process.env.REACT_APP_API_URL}/schemaComparison/${id}`,
        {headers: headers(), cancelToken: source.token},
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: scActions.LOAD_SAVED_RUN_SUCCESS, payload: json}))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          dispatch({type: scActions.LOAD_SAVED_RUN_FAILURE, payload: error, error: true});
        });
  };
}

export function exportPdf(payload) {
  return () => axios.post(
      `${process.env.REACT_APP_API_URL}/schemaComparison/report/pdf`,
      payload,
      {headers: headers(), responseType: 'blob'},
  ).then((res) => res.data);
}

// Persist the full detail payload for an already-run comparison (the user opts
// to "save for audit" from the results page). Returns the {status, error, ...}
// envelope so the caller can surface success/failure.
export function saveComparison(comparisonId, payload) {
  return () => axios.post(
      `${process.env.REACT_APP_API_URL}/schemaComparison/${comparisonId}/save`,
      payload,
      {headers: headers()},
  ).then((res) => res.data);
}

export function clearResult() {
  return {type: scActions.CLEAR_RESULT};
}
